<template>
  <div class="address-delivery-time-table">
    <div class="address-delivery-time-table-item" v-for="item, index in items" :key="index">
      <div class="address-delivery-time-table-item-header">
        {{ item.title }}
      </div>
      <div class="address-delivery-time-table-item-body">
        <div class="address-delivery-time-table-item-el" v-for="el, i in item.list" :key="`el-${i}`">
          <p>{{ el.time }}</p>
          {{ el.cities }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const items = [
  {
    title: 'Утреннее время',
    list: [
      {
        time: '07:00 - 09:00',
        cities: 'Москва, Санкт-Петербург, Екатеринбург'
      },
      {
        time: '07:00 - 10:00',
        cities: 'Остальные города'
      },
    ]
  },
  {
    title: 'Стандартное время',
    list: [
      {
        time: '09:00 - 22:00',
        cities: 'Москва, Санкт-Петербург, Екатеринбург'
      },
      {
        time: '10:00 - 20:00',
        cities: 'Остальные города'
      },
    ]
  },
  {
    title: 'Вечернее время',
    list: [
      {
        time: '22:00 - 00:00',
        cities: 'Москва, Санкт-Петербург'
      },
      {
        time: '20:00 - 00:00',
        cities: 'Остальные города'
      },
    ]
  },
  {
    title: 'Ночное время',
    list: [
      {
        time: '00:00 - 07:00',
        cities: 'Ночной забор доступен только в Москве, Санкт-Петербурге и Екатеринбурге'
      }
    ]
  }
]
</script>

<style lang="scss" scoped>
.address-delivery-time-table {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: $box-gray;
  border-radius: 4px;

  @media only screen and (max-width: $pub-xs) {
    grid-template-columns: 1fr;
    grid-gap: 20px;
    background: transparent;
  }

  &-item {
    @media only screen and (max-width: $pub-xs) {
      background: $box-gray;
    }

    &-header {
      color: $font-low;
      font-weight: 500;
      background-color: $card-border-gray;
      padding: 10px 30px;
      border-bottom: 5px solid $white;

      @media only screen and (max-width: $pub-sm) {
        padding-left: 15px;
        padding-right: 15px;
      }
    }

    &-body {
      background-color: $box-gray;
      border-right: 1px solid $border-gray;
      margin: 24px auto;
      min-height: 148px;

      @media only screen and (max-width: $pub-xs) {
        border-right: none;
      }
    }

    &-el {
      padding: 0 30px;
      color: $font-low;
      min-height: 70px;

      @media only screen and (max-width: $pub-sm) {
        padding-left: 15px;
        padding-right: 15px;
      }
      
      &:not(:first-child) {
        margin-top: 20px;
      }

      p {
        color: $font-medium;
        font-weight: 500;
      }
    }
  }

  &-item:last-child {
    .address-delivery-time-table-item-body {
      border-right: none;
    }
  }
}
</style>